import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

/**
 * Bind fancybox functionality to each unique gallery block
 */
const galleries = document.querySelectorAll(`.gallery`);
galleries.forEach((gallery, i) => {
  const galleryImageWrappers = gallery.querySelectorAll(
    `.fancybox-gallery-link`
  );
  galleryImageWrappers.forEach((wrapper) => {
    wrapper.dataset.fancybox = `gallery-${i + 1}`;
  });

  Fancybox.bind(`[data-fancybox='gallery-${i + 1}']`, {
    on: {
      reveal: (fancybox, slide) => {
        const originalImageStyles = gallery.querySelector(`.gallery-image`);

        const computedStyle = getComputedStyle(
          originalImageStyles
        ).getPropertyValue(`--advanced-image-controls`);

        slide.contentEl.style.filter = computedStyle;

        const overlayColor = gallery.querySelector(`.gallery-item`);
        const computedOverlay = getComputedStyle(overlayColor).getPropertyValue(
          `--gallery-image-overlay`
        );
        if (computedOverlay) {
          const overlayDiv = document.createElement(`div`);
          overlayDiv.classList.add(`fancybox-image-overlay-container`);
          overlayDiv.style.backgroundColor = computedOverlay;

          const selectedImg = slide.imageEl;
          selectedImg.after(overlayDiv);
        }
      },
    },
    Thumbs: {
      on: {
        createSlide: (thumbs, slide, thumbSlideEl) => {
          const originalImageStyles = gallery.querySelector(`.gallery-image`);
          const computedStyle = getComputedStyle(
            originalImageStyles
          ).getPropertyValue(`--advanced-image-controls`);

          if (computedStyle) {
            thumbSlideEl.style.filter = computedStyle;
          }

          const overlayColor = gallery.querySelector(
            `.fancybox-gallery-link .gallery-item`
          );
          const computedOverlay = getComputedStyle(
            overlayColor
          ).getPropertyValue(`--gallery-image-overlay`);

          if (computedOverlay) {
            const overlayDiv = document.createElement(`div`);
            overlayDiv.classList.add(`thumbnail-overlay-container`);
            overlayDiv.style.backgroundColor = computedOverlay;

            const slideImg = thumbSlideEl.querySelector(
              `.f-thumbs__slide__img`
            );
            slideImg.after(overlayDiv);
          }
        },
      },
    },
  });
});

/**
 * Bind fancybox functionality to each unique masonry gallery block
 */
const masonryGalleries = document.querySelectorAll(`.masonry-gallery`);
masonryGalleries.forEach((gallery, i) => {
  const masonryGalleryImageWrappers = gallery.querySelectorAll(
    `.masonry-gallery-image-wrapper`
  );
  masonryGalleryImageWrappers.forEach((wrapper) => {
    wrapper.dataset.fancybox = `masonry-gallery-${i + 1}`;
  });

  Fancybox.bind(`[data-fancybox='masonry-gallery-${i + 1}']`, {
    // Your custom options
    on: {
      reveal: (fancybox, slide) => {
        const originalImageStyles = gallery.querySelector(
          `.masonry-gallery-image`
        );
        const computedStyle = getComputedStyle(
          originalImageStyles
        ).getPropertyValue(`--masonry-advanced-image-controls`);

        if (computedStyle) {
          slide.contentEl.style.filter = computedStyle;
        }

        const overlayColor = gallery.querySelector(
          `.masonry-gallery-image-wrapper .gallery-item`
        );
        const computedOverlay = getComputedStyle(overlayColor).getPropertyValue(
          `--masonry-gallery-image-overlay`
        );
        if (computedOverlay) {
          const overlayDiv = document.createElement(`div`);
          overlayDiv.classList.add(`fancybox-image-overlay-container`);
          overlayDiv.style.backgroundColor = computedOverlay;

          const selectedImg = slide.imageEl;
          selectedImg.after(overlayDiv);
        }
      },
    },
    Thumbs: {
      on: {
        createSlide: (thumbs, slide, thumbSlideEl) => {
          const originalImageStyles = gallery.querySelector(
            `.masonry-gallery-image`
          );
          const computedStyle = getComputedStyle(
            originalImageStyles
          ).getPropertyValue(`--masonry-advanced-image-controls`);

          if (computedStyle) {
            thumbSlideEl.style.filter = computedStyle;
          }

          const overlayColor = gallery.querySelector(`.gallery-item`);
          const computedOverlay = getComputedStyle(
            overlayColor
          ).getPropertyValue(`--masonry-gallery-image-overlay`);

          if (computedOverlay) {
            const overlayDiv = document.createElement(`div`);
            overlayDiv.classList.add(`thumbnail-overlay-container`);
            overlayDiv.style.backgroundColor = computedOverlay;

            const slideImg = thumbSlideEl.querySelector(
              `.f-thumbs__slide__img`
            );
            slideImg.after(overlayDiv);
          }
        },
      },
    },
  });
});
